import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
const InvoiceReviewPill = ({ reviewStatus, fullWidth }) => {
    const baseClass = twMerge('inline-flex h-6 items-center rounded-full font-medium px-2.5 text-xs whitespace-nowrap', fullWidth ? 'w-full justify-center' : '');
    switch (reviewStatus) {
        case 'REVIEW_PENDING':
            return _jsx("div", { className: twMerge(baseClass, 'border-2 border-[#e0e0e0] bg-white text-[#05690d]'), children: "Under Review" });
        case 'REVIEW_APPROVED':
            return _jsx("div", { className: twMerge(baseClass, 'bg-[#d7f7c2] text-[#05690d]'), children: "Approved" });
        case 'REVIEW_REJECTED':
            return _jsx("div", { className: twMerge(baseClass, 'bg-red-100 font-semibold text-red-900'), children: "In Dispute" });
        default:
            return _jsx("div", { className: twMerge(baseClass, 'bg-[#cff5f6] text-[#0055bc]'), children: "No Review" });
    }
};
export default InvoiceReviewPill;
//# sourceMappingURL=invoice-review-pill.js.map